import { FrontPage } from "../front/frontPage";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { AbortDictionary, getApiCall, getFileApiCall, postApiCall } from "./tokenService";
import { ModifiedRecordListItems } from "../front/modifiedRecordListItems";
import { FrontToDoItemGroups } from "../front/frontToDoItemGroups";
import { SessionState } from "../session/sessionState";
import { ITypedOption, TypedOptionSave } from "../common/typedOption";
import { IPagePanel } from "../common/pagePanel";
import { FrontFileItems } from "../front/frontFileItems";

export interface IOtpSuccess {
    otp: string;
}

export class OtpSuccess implements IOtpSuccess {
    otp: string;

    constructor();
    constructor(obj: IOtpSuccess);
    constructor(obj?: any) {
        this.otp = obj && obj.otp || "";
    }
}

//Abort
const frontAborts = new AbortDictionary();

export const getFrontPage = (): Promise<FrontPage> => {
    return getApiCall("api/front", FrontPage);
};

export const getTime = (): Promise<void> => {
    return getApiCall("api/front/gettime", null);
};

export const setCulture = (culture: string): Promise<ApiSuccess> => {
    return postApiCall("api/front/setculture", ApiSuccess, JSON.stringify({
        culture
    }));
};

export const getOtp = (code: string): Promise<OtpSuccess> => {
    return getApiCall("api/front/getotp?id=" + code, OtpSuccess);
};

export const getSessionState = (): Promise<SessionState> => {
    return getApiCall("api/front/getsessionstate", SessionState);
};

export const setActiveCompany = (companyId: string): Promise<SessionState> => {
    return postApiCall("api/front/setactivecompany?id=" + companyId, SessionState);
};

export const getModifiedRecordListItems = (userModified: boolean): Promise<ModifiedRecordListItems> => {
    const operationId = "getModifiedRecordListItems" + (userModified ? "_U" : "_C");
    frontAborts.abort(operationId);
    return postApiCall("api/front/" + (userModified ? "usermodifiedrecords" : "companymodifiedrecords"), ModifiedRecordListItems, null, (abortId: string) => {
        frontAborts.add(operationId, abortId);
    }).finally(() => {
        frontAborts.remove(operationId);
    });
};

export const getFrontToDoItemGroups = (): Promise<FrontToDoItemGroups> => {
    const operationId = "frontToDo";
    frontAborts.abort(operationId);
    return postApiCall("api/front/todoitemgroups", FrontToDoItemGroups, null, (abortId: string) => {
        frontAborts.add(operationId, abortId);
    }).finally(() => {
        frontAborts.remove(operationId);
    });
};

export const getDocumentBrowserFrontFileItems = (): Promise<FrontFileItems> => {
    const operationId = "frontDocumentBrowser";
    frontAborts.abort(operationId);
    return postApiCall("api/front/documentbrowserdocuments", FrontFileItems, null, (abortId: string) => {
        frontAborts.add(operationId, abortId);
    }).finally(() => {
        frontAborts.remove(operationId);
    });
};

export const downloadDocumentBrowserDocument = (id: string): Promise<string> => {
    return getFileApiCall("api/front/downloaddocumentbrowserdocument?id=" + id);
};

export const saveImages = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/front/savepictures", ApiSuccess, JSON.stringify(obj));
};

export const saveModifiedRecords = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/front/savemodifiedrecords", ApiSuccess, JSON.stringify(obj));
};

export const saveMessages = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/front/savemessages", ApiSuccess, JSON.stringify(obj));
};

export const saveBanner = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/front/savebanner", ApiSuccess, JSON.stringify(obj));
};

export const saveFrontPanels = (panels: IPagePanel[]): Promise<ApiSuccess> => {
    return postApiCall("api/front/savepanels", ApiSuccess, JSON.stringify({ panels }));
};

export const saveUserParameters = (parameters: ITypedOption[]): Promise<ApiSuccess> => {
    return postApiCall("api/front/saveuserparameters", ApiSuccess, JSON.stringify({ parameters: parameters.map(i => new TypedOptionSave(i)) }));
};